import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
export default {
  name: "Alteration",
  components: {
    Step1: Step1,
    Step2: Step2,
    Step3: Step3,
    Step4: Step4
  },
  data: function data() {
    return {
      description: '将一个冗长或用户不熟悉的表单任务分成多个步骤，指导用户完成。',
      currentTab: 0,
      userList: {},
      // form
      form: null
    };
  },
  methods: {
    // handler
    nextStep: function nextStep(data) {
      this.userList = data;
      if (this.currentTab < 4) {
        this.currentTab += 1;
      }
    },
    prevStep: function prevStep(data) {
      this.userList = data;
      if (this.currentTab > 0) {
        this.currentTab -= 1;
      }
    },
    finish: function finish() {
      this.currentTab = 0;
    }
  }
};